import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import api from '@/lib/api';
import type { Conferencia, DetalheDaFolha } from './tipos';

/** A competência aberta, compartilhada por todas as telas do wizard. */
export function useFolha() {
  const { folhaId } = useParams();

  const folha = useQuery({
    queryKey: ['folha', folhaId],
    queryFn: async () => (await api.get<{ data: DetalheDaFolha }>(`/folhas/${folhaId}`)).data.data,
    enabled: Boolean(folhaId),
    // Competência excluída não volta insistindo: mostra logo que não existe.
    retry: (falhas, erro) => (erro as { response?: { status?: number } }).response?.status !== 404 && falhas < 3,
  });

  return { folhaId, ...folha };
}

/** A conferência é pedida à parte: ela recalcula tudo e é a parte mais cara. */
export function useConferencia(folhaId?: string, habilitada = true) {
  return useQuery({
    queryKey: ['folha-conferencia', folhaId],
    queryFn: async () => (await api.get<{ data: Conferencia }>(`/folhas/${folhaId}/conferencia`)).data.data,
    enabled: Boolean(folhaId) && habilitada,
  });
}
